import { NgModule } from '@angular/core';
import { ComponentSharedModule } from '@components/component.shared.module';
import { UiThemePreviewComponent } from '@components/ui-theme-preview/ui-theme-preview';

@NgModule({
    imports: [
        ComponentSharedModule,
    ],
    exports: [UiThemePreviewComponent],
    declarations: [UiThemePreviewComponent],
})
export class UiThemePreviewModule { }
